import { forwardRef } from "react";
import { TimePicker as AntTimePicker } from "antd";

const CommonTimePicker = forwardRef(
  ({ format = "hh:mm a", confirmation = false, value, ...props }, ref) => {
    return (
      <AntTimePicker
        ref={ref}
        format={format}
        value={value ?? null}
        needConfirm={confirmation}
        {...props}
      />
    );
  },
);

CommonTimePicker.displayName = "CommonTimePicker";

export default CommonTimePicker;
